export const Notfi = [
    {
        date: "16 June, 2019",
        text: "Great School manag mene esom tus eleifend lectus sed maximus mi faucibusnting.",
        author: "Jennyfar Lopez",
        timeAgo: "5 min ago",
    },
    {
        date: "16 June, 2019",
        text: "Great School manag printing.",
        author: "Jennyfar Lopez",
        timeAgo: "5 min ago",
    },
    {
        date: "16 June, 2019",
        text: "Great School manag printing.",
        author: "Jennyfar Lopez",
        timeAgo: "5 min ago",
    },
    {
        date: "16 June, 2019",
        text: "Great School manag printing.",
        author: "Jennyfar Lopez",
        timeAgo: "5 min ago",
    },

];
